import Btn from '../utils/btn';

const func = $target => {
    var $btn = new Btn($target.find('button[type="submit"]'));
    var $input = $target.find('input[name^="purchasables"][name$="[qty]"]');

    $target.on('submit', function(e) {
        var $qty = $target.find('[name="qty"]').val();
        $input.each(function() {
            $(this).val(Number($(this).val()) * $qty);
        });

        $btn.process();

    });
};

export default func;